import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'contentData', 'button']
  static values = { url: String };


  toggleContent(event) {
    const controller = this
    let button = event.currentTarget
    if (!controller.hasContentTarget) return
    if (controller.hasContentDataTarget) {
      controller.contentTarget.classList.toggle('hidden')
      if (controller.contentTarget.classList.contains('hidden')) {
        controller.setCollapsed(button)
      } else {
        controller.setExpanded(button)
      }
    } else {
      fetch(controller.urlValue)
        .then((r) => r.text())
        .then((html) => {
          controller.contentTarget.disabled = false
          const fragment = document
            .createRange()
            .createContextualFragment(html);
          controller.contentTarget.appendChild(fragment);
        });
      controller.setExpanded(button)
      controller.contentTarget.classList.remove('hidden')
    }
  }


  setExpanded(button) {
    let icon = button.querySelector('i.indicator.icon');
    if (button._tippy) {
      button._tippy.setContent('Collapse')
    } else {
      button.dataset.tippyContent = 'Collapse'
    }
    icon.classList.remove('collapsed')
    icon.classList.add('expanded')
  }

  setCollapsed(button) {
    let icon = button.querySelector('i.indicator.icon');
    if (button._tippy) {
      button._tippy.setContent('Expand')
    } else {
      button.dataset.tippyContent = 'Expand'
    }
    icon.classList.remove('expanded')
    icon.classList.add('collapsed')
  }
}
